import { DealDropdown } from '@dealstack/frontend/app/pages/Project/DealDashboard/DealDropdown/DealDropdown';
import { ROUTES } from '@dealstack/frontend/app/pages/Routing/routes';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { SummaryDealTct } from '@dealstack/shared/lib/generated';
import { generatePath } from 'react-router-dom';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';
import { AddBreadcrumbItem } from './useBreadcrumbs.types';

export const makeDealPageBreadcrumbs = ({
	dropdownPlaceholder,
	dealName,
	tCommonUi,
	dealId,
	deals,
	onlyDealDropdown = false,
}: {
	dropdownPlaceholder?: string;
	dealName?: string;
	tCommonUi: TranslateFunction<I18Namespaces.COMMON_UI>;
	dealId?: string;
	isMipPage?: boolean;
	deals?: SummaryDealTct[];
	onlyDealDropdown?: boolean;
}): AddBreadcrumbItem[] => {
	return [
		...(onlyDealDropdown
			? []
			: [
					{
						name: tCommonUi('breadcrumbs.my_deals'),
						url: ROUTES.DASHBOARD,
						hideInPageHeader: true,
					},
				]),
		{
			name: dealName ?? 'Deal',
			url: generatePath(ROUTES.DEAL, { dealId: dealId ?? '' }),
			hideInPageHeader: true,
			element: (
				<DealDropdown
					key="deal-dropdown"
					currentDealId={dealId}
					deals={deals || []}
					placeholderName={dropdownPlaceholder}
				/>
			),
		},
	];
};
